<script setup>
defineProps({
  body: {
    type: String,
    required: true
  }
})
</script>
<template>
  <div class="pastOverview">
    <h3 class="heading">
      天気概況
    </h3>
    <div class="textarea">
      <p class="text">
        {{ body }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pastOverview {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .heading {
    color: #303030;
    font-size: 18px;
    font-weight: 600;
    line-height: 1em;
  }
  .textarea {
    display: flex;
    flex-direction: column;
    gap: 5px;
    .title {
      color: #000;
      font-size: 15px;
      font-weight: 600;
      line-height: 1.67em;
    }
    .text {
      color: #000;
      font-size: 15px;
      font-weight: 300;
      line-height: 1.6em;
    }
  }
  @media (any-hover: hover) {
  }
}
.main {
  .pastOverview {
    @media (min-width: 830px) {
    }
  }
}
</style>
